
import * as offer from './offer';
import {getUrlParam} from '../pages/util/common'
import '@ali/lib-mtop';
window.lib.mtop.config.prefix = 'h5api';
window.lib.mtop.config.subDomain = getUrlParam('debugMode') == 1 ? 'wapa' : 'm';
window.lib.mtop.config.mainDomain = '1688.com';

export const mtop = (api, data, ...options) => {
  return window.lib.mtop.request({
    api, // 必须
    v: '1.0',  // 必须
    data,
    ecode: 0,   // 必须（注意2）
    type: 'GET',   // 非必须。请求类型（GET/POST），默认是GET
    dataType: 'jsonp', // 非必须。数据类型（jsonp/originaljsonp/json），默认jsonp
    timeout: 20000, // 非必须。接口超时设置，默认为20000ms
    ...options,
  }, (res) => {
    goldlog.record(
      "/ifission.ifission.autoWW",
      "CLK",
      `code=${res.data? res.data.code : ''}&msg=${res.data? res.data.msg : ''}`,
      "GET"
    );
  });
};

export const sendWW = (eurl, itemId) => {
  mtop('mtop.hamlet.engine.gateway', {
    apiEngineType: '2',
    api: 'cplEnquiry',
    params: JSON.stringify({
      sk: "d816e70d380f8694a49f2d4aa2aae51d",
      ak: "mtop",
      paramMap: {
        bizId: "_360_pcpmp",
        items:[
          {
            "eurl": eurl,
            "itemType": "AD",
            "itemId": itemId
          }
        ]
      }
    })
  })
}

export default {
    ...offer,
};

